export default __webpack_public_path__ + "assets/images/ca1423a3313953017a034d0e340a7ed8.png";